import { useEffect, useState } from 'react'

/**
 * The one breakpoint the shell switches on. Below it the web app renders the
 * phone experience: stacked screens with a flat header, the way the mobile
 * client lays them out, instead of the sidebar workspace.
 */
export const NARROW_QUERY = '(max-width: 800px)'

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(
    () =>
      typeof window !== 'undefined' && window.matchMedia(NARROW_QUERY).matches,
  )
  useEffect(() => {
    const query = window.matchMedia(NARROW_QUERY)
    const changed = () => setNarrow(query.matches)
    changed()
    query.addEventListener('change', changed)
    return () => query.removeEventListener('change', changed)
  }, [])
  return narrow
}
